import auth from '@/routers/auth'
import { Router } from 'express'

const router = Router()

router.use('/auth', auth)

export default router
